import { PagedSearch } from 'src/app/shared';

export class ArticleTypeSearchDto extends PagedSearch {}
